/**
 * Outbox View Tracker
 * - On product pages: pings the worker to record a view
 * - On collection pages: reorders the grid by view count when "Best Selling" is active
 *
 * Requires window.outboxViewTracker to be set before this script runs (done in theme.liquid).
 */
(function () {
  'use strict';

  var config = window.outboxViewTracker;
  if (!config || !config.workerUrl || config.workerUrl.indexOf('REPLACE') !== -1) return;

  var WORKER_URL = config.workerUrl.replace(/\/$/, '');

  // ─── PRODUCT PAGE: fire-and-forget view tracking ──────────────────────────
  if (config.productId) {
    var payload = JSON.stringify({ productId: String(config.productId) });
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(
          WORKER_URL + '/track',
          new Blob([payload], { type: 'application/json' })
        );
      } else {
        fetch(WORKER_URL + '/track', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: payload,
          keepalive: true
        });
      }
    } catch (_) {}
    return; // nothing else to do on product pages
  }

  // ─── COLLECTION PAGE: reorder grid items by view count ────────────────────
  var gridContainer = document.getElementById('ProductGridContainer');
  if (!gridContainer) return;

  function getCurrentSortBy() {
    return new URLSearchParams(window.location.search).get('sort_by') || '';
  }

  function isBestSellingActive() {
    // 1. Check URL param — most explicit signal
    var sort = getCurrentSortBy();
    if (sort === 'best-selling') return true;
    if (sort !== '') return false; // some other sort explicitly chosen

    // 2. No URL param — check the actual sort dropdown value (most reliable)
    var sortSelect = document.getElementById('SortBy') || document.getElementById('SortBy-mobile');
    if (sortSelect) return sortSelect.value === 'best-selling';

    // 3. No dropdown (sorting disabled on this collection) — fall back to data attribute
    var grid = document.getElementById('product-grid');
    if (!grid) return false;
    var defaultSort = grid.dataset.defaultSort || '';
    return defaultSort === 'best-selling' || defaultSort === 'best_selling' || defaultSort === '';
  }

  function reorderByViews() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var items = Array.from(grid.querySelectorAll('li[data-product-id]'));
    if (items.length < 2) return;

    var ids = items.map(function (li) { return li.dataset.productId; }).join(',');

    fetch(WORKER_URL + '/sorted?ids=' + encodeURIComponent(ids))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.sorted || !data.sorted.length) return;
        var idToEl = {};
        items.forEach(function (li) { idToEl[li.dataset.productId] = li; });
        // Append in sorted order; products with 0 views keep their original relative order
        data.sorted.forEach(function (id) {
          var el = idToEl[id];
          if (el) grid.appendChild(el);
        });
      })
      .catch(function () {}); // silently fail — original Shopify order stays
  }

  // Initial page load
  if (isBestSellingActive()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reorderByViews);
    } else {
      reorderByViews();
    }
  }

  // After facets.js AJAX sort change: it replaces #ProductGridContainer innerHTML,
  // so we watch for that mutation and re-apply the sort if needed.
  var observer = new MutationObserver(function () {
    if (isBestSellingActive()) {
      // Small delay to ensure the new DOM is fully painted
      setTimeout(reorderByViews, 60);
    }
  });
  observer.observe(gridContainer, { childList: true });
})();
